module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "boxx"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "collection_scrollbar"
  }, [_c('vue-form', {
    staticClass: "collection_division_paddi",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row row_paddi_manage"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.cdaName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Ward / Society / Mohalla")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.collectionDivisions.cdaName),
      expression: "collectionDivisions.cdaName"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "25",
      "type": "text",
      "name": "cdaName",
      "required": "",
      "placeholder": "Ward / Society / Mohalla",
      "pattern": "^[a-zA-Z][a-zA-Z0-9 @./#+-_]{0,25}[^\\s]$"
    },
    domProps: {
      "value": (_vm.collectionDivisions.cdaName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.collectionDivisions, "cdaName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback validation_msg",
    attrs: {
      "name": "cdaName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                                                Ward / Society / Mohalla is a required field\n                                            ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                                                Alphabets/Numbers/Special Characters are allowed.\n                                            ")])])], 1)], 1)]), _vm._v(" "), _c('button', {
    staticClass: "add_more_btn mr-2 btn gradientbt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addLineInfo()
      }
    }
  }, [_vm._v("\n                                Add Line\n                            ")]), _vm._v(" "), (_vm.showLine) ? _c('button', {
    staticClass: "add_more_btn mr-2 btn gradientbt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showLine = false
      }
    }
  }, [_vm._v("\n                                Remove Line\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.showLine) ? _c('div', {
    staticClass: "row"
  }, [(_vm.$route.params && !_vm.$route.params._id) ? _c('button', {
    staticClass: "add_more_btn mr-2 btn gradientbt",
    attrs: {
      "type": "button",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": function($event) {
        _vm.addMore()
      }
    }
  }, [_vm._v("\n                                    Add More\n                                ")]) : _vm._e(), _vm._v(" "), _vm._l((this.collectionDivisions
    .lineTowerHouse), function(lineTowerHouse, index) {
    return _c('div', {
      key: index,
      staticClass: "linesadded_row"
    }, [_c('div', {
      staticClass: "linesadded_wrp"
    }, [_c('label', [_vm._v("Line / Tower Name")]), _vm._v(" "), _c('div', {
      staticClass: "linesadded_inner"
    }, [_c('validate', {
      staticClass: "form-group required-field",
      class: _vm.fieldClassName(lineTowerHouse.name),
      attrs: {
        "auto-label": ""
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lineTowerHouse.name),
        expression: "lineTowerHouse.name"
      }],
      staticClass: "form-control lineTower",
      attrs: {
        "required": _vm.collectionDivisions.lineTowerHouse[index].name == '' ? true : false,
        "maxlength": "25",
        "type": "text",
        "id": index,
        "name": 'collectionDivisions.lineTowerHouse[' +
          index +
          '][\'name\']',
        "placeholder": "Line / Tower",
        "pattern": "^[a-zA-Z][a-zA-Z0-9 @./#+-_]{0,25}[^\\s]$"
      },
      domProps: {
        "value": (lineTowerHouse.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(lineTowerHouse, "name", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('field-messages', {
      staticClass: "form-control-feedback",
      attrs: {
        "name": 'collectionDivisions.lineTowerHouse[' +
          index +
          '][\'name\']',
        "show": "$touched || $submitted"
      }
    }, [_c('div', {
      attrs: {
        "slot": "required"
      },
      slot: "required"
    }, [_vm._v("\n                                                        Line/Tower name is required.\n                                                    ")]), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "pattern"
      },
      slot: "pattern"
    }, [_vm._v("\n                                                        Alphabets/Numbers/Special Characters are allowed.\n                                                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "houses_label_wrp"
    }, [_c('label', [_vm._v("Houses:")])]), _vm._v(" "), _c('div', {
      staticClass: "houses_wrp"
    }, [_vm._l((lineTowerHouse.houses), function(house, houseIndex) {
      return _c('div', {
        key: houseIndex,
        staticClass: "flex"
      }, [_c('div', [_c('validate', {
        staticClass: "form-group required-field",
        class: _vm.fieldClassName(house.hnNo),
        attrs: {
          "auto-label": ""
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (house.hnNo),
          expression: "house.hnNo"
        }],
        staticClass: "form-control",
        attrs: {
          "required": lineTowerHouse.houses[houseIndex].hnNo == '' ? true : false,
          "maxlength": "10",
          "type": "text",
          "name": '' + houseIndex + index + '',
          "placeholder": "H No.",
          "pattern": "^[a-zA-Z]|[0-9][a-zA-Z0-9 @./#+-_]{0,10}[^\\s]$"
        },
        domProps: {
          "value": (house.hnNo)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(house, "hnNo", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('field-messages', {
        staticClass: "form-control-feedback",
        attrs: {
          "name": '' + houseIndex + index + '',
          "show": "$touched || $submitted"
        }
      }, [_c('div', {
        attrs: {
          "slot": "required"
        },
        slot: "required"
      }, [_vm._v("\n                                                            House Number is required.\n                                                        ")]), _vm._v(" "), _c('div', {
        attrs: {
          "slot": "pattern"
        },
        slot: "pattern"
      }, [_vm._v("\n                                                            Alphabets/Numbers/Special Characters are\n                                                            allowed.\n                                                        ")])])], 1)], 1), _vm._v(" "), _c('button', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (lineTowerHouse.houses.length > 1),
          expression: "lineTowerHouse.houses.length > 1"
        }],
        staticClass: "mr-2 btn gradientbt",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.removeHouse(index, houseIndex)
          }
        }
      }, [_vm._v("\n                                                -\n                                            ")])])
    }), _vm._v(" "), (_vm.$route.params && !_vm.$route.params._id) ? _c('button', {
      staticClass: "mr-2 btn gradientbt",
      attrs: {
        "type": "button",
        "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
      },
      on: {
        "click": function($event) {
          _vm.addMoreHouses(index)
        }
      }
    }, [_vm._v("\n                                            +\n                                        ")]) : _vm._e()], 2), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.collectionDivisions.lineTowerHouse.length > 1),
        expression: "collectionDivisions.lineTowerHouse.length > 1"
      }],
      staticClass: "add_more_btn mr-2 btn gradientbt",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.remove(index)
        }
      }
    }, [_vm._v("\n                                        Remove\n                                    ")])])
  })], 2) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("\n                            Cancel\n                        ")]), _vm._v(" "), (_vm.$route.params && !_vm.$route.params._id) ? _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createCollectionDivisions
    }
  }, [_vm._v("\n                            Save\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id) ? _c('button', {
    staticClass: "btn gradientbt mr-5",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid) &&
        _vm.lineList &&
        _vm.houseList
    },
    on: {
      "click": _vm.updateCollectionDivisions
    }
  }, [_vm._v("\n                            Update\n                        ")]) : _vm._e()])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a66f2f20", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a66f2f20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/wasteCollectionArea/collectionDivisionCreate.vue
// module id = 2372
// module chunks = 0